import { request } from '@/common/request';
import { apiOrigin } from '@/common/config';

export const queryGuideByPage = data => {
    return request({
        url: `${apiOrigin}/api/saas/backend/userGuide/queryByPage`,
        method: 'post',
        data
    });
};
